import { mapMultiSelectDropDownField } from '@ninja/utilities';
import { useAppPlatformContextOptions } from '../../../../../../contexts/app';
import { useBenefitCategories } from '../../../../../app-init-data';
import { QuotePlanSchema } from '../../../server/map-quotes';
import { QuoteFilters } from '../useQuoteFilterSchema';

export const usePlanKeyBenefits = (originalQuotes: QuotePlanSchema[]) => {
	const { translate } = useAppPlatformContextOptions();
	const { benefitCategories } = useBenefitCategories();

	const availableKeyBenefits: { benefitCategoryId: number; benefitName: string }[] = [];

	originalQuotes?.forEach((q) => {
		q.planKeyBenefits?.forEach((kb) => {
			const benefit = benefitCategories.find((q) => q.id === kb.benefitCategoryId && kb.isKeyBenefit);

			if (benefit && availableKeyBenefits.findIndex((k) => k.benefitCategoryId === kb.benefitCategoryId) === -1)
				availableKeyBenefits.push({
					...kb,
					benefitName: benefit?.name ?? '',
				});
		});
	});

	const getKeyBenefits = mapMultiSelectDropDownField<
		QuoteFilters,
		{ benefitCategoryId: number; benefitName: string },
		'benefitCategoryId'
	>({
		field: 'keyBenefitId',
		isEditable: true,
		options: availableKeyBenefits,
		label: translate('quote-list:filters.key-benefits'),
		placeholder: translate('quote-list:select'),
		isHidden: false,
		valueKey: 'benefitCategoryId',
		labelKey: 'benefitName',
		cancelButtonText: translate('quote-list:filters.cancel'),
		applyButtonText: translate('quote-list:filters.apply'),
	});

	return { getKeyBenefits };
};
